

// A page that allows the user to view and edit their profile

import { userAtom, userImageAtom, userNameAtom } from "../../state/user"
import { useAtomValue, useSetAtom } from "jotai"
import './userProfile.css'
const UserProfile = () => {

  const user = useAtomValue(userAtom)
  const setUserName = useSetAtom(userNameAtom)
  const setUserProfileImg = useSetAtom(userImageAtom)

  // Generate a random fun user name from scratch 
  function generateRandomUserName() {
    const adjectives = ['Crazy', 'Dumb', 'Stupid', 'Funny', 'Cool', 'Awesome', 'Fantastic', 'Incredible', 'Amazing', 'Wonderful']
    const nouns = ['Dog', 'Cat', 'Bird', 'Fish', 'Bear', 'Tiger', 'Lion', 'Elephant', 'Zebra', 'Giraffe']
    return `${adjectives[Math.floor(Math.random() * adjectives.length)]} ${nouns[Math.floor(Math.random() * nouns.length)]}`
  }

  


  return (
    <div className="userProfilePage">
      {/* User name section */}
      <div   className="userProfileSection">
        <h1>Name</h1>
        <input type="text" value={user.username} placeholder={user.username} onChange={(e) => {
          setUserName(e.target.value)
        }} />
        <button onClick={() => {
          const randomUserName = generateRandomUserName()
          setUserName(randomUserName)
        }}>Generate</button>
      </div>
      {/* User image section */}
      <div className="userProfileSection">
        <img src={user.profileImg} alt="Profile" />
        <input type="text" value={user.profileImg} placeholder={user.profileImg} onChange={(e) => {
          setUserProfileImg(e.target.value)
        }} />
      </div>
    </div>
  )
}

export default UserProfile